import { FC, useEffect, useState } from "react";
import "./ModalAccessPageCollapseInsert.scss";
import ModalDefault from "../../components/ModalDefault/ModalDefault";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../providers/AuthProvider";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, FormCheck, FormGroup, Row } from "react-bootstrap";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { schema } from "./Validate";
import ModalOffCanvas from "../ModalOffCanvas/ModalOffCanvas";
import IconGallery from "../IconGallery/IconGallery";
import { BvIcon } from "bevi-icon";
import { InferType } from "yup";
import { icons } from "../../enums/Icons";

interface ModalAccessPageCollapseInsertProps {
  show: boolean;
  onClose: () => void;
  handlePagesAdd: (data: any, uptade: boolean) => void;
  pageEdit?: FormValues;
  isEdit: boolean;
}

export type FormValues = InferType<typeof schema>;

type Icon = {
  icon: string;
  name: string;
};

const defaultValues: FormValues = {
  name: "",
  icon: "",
  collapse: false,
  layout: "",
  description: "",
};

const ModalAccessPageCollapseInsert: FC<ModalAccessPageCollapseInsertProps> = ({
  show,
  onClose,
  handlePagesAdd,
  pageEdit,
  isEdit,
}) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [showModalOffCanvas, setShowModalOffCanvas] = useState<boolean>(false);
  const [iconsFiltered, setIconsFiltered] = useState<Icon>();
  const [iconEdit, setIconEdit] = useState<Icon[]>([]);

  const { onInvalid } = useAuth();

  const {
    handleSubmit,
    register,
    setValue,
    reset,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: defaultValues,
    resolver: yupResolver(schema) as any,
  });

  const newPages = () => {
    reset(defaultValues);
    setIconsFiltered({ icon: "", name: "" });
    setIconEdit([]);
    setValue("collapse", false);
  };

  useEffect(() => {
    if (show) {
      if (isEdit) {
        reset(pageEdit as FormValues);
        setIconEdit(
          pageEdit?.icon
            ? icons.items.filter((item) => item.icon === pageEdit?.icon)
            : []
        );
        setValue("collapse", false);
        setIconsFiltered({ icon: "", name: "" });
      } else {
        newPages();
      }
    }
  }, [show]);

  const handleClose = () => {
    newPages();
    onClose();
  };

  const onSubmit = async (data: any) => {
    handlePagesAdd(data, isEdit);
    handleClose();
  };

  const showOffCanvas = (show: boolean) => {
    setShowModalOffCanvas(show);
  };

  const handleSelect = (icon: string, name: string) => {
    setIconsFiltered({ icon, name });
    setValue("icon", icon);
    setShowModalOffCanvas(false);
  };

  const renderContent = () => {
    return (
      <Row>
        <Col md={12}>
          <FormGroup className="form-group">
            <label htmlFor="name">NOME *</label>
            <input
              className={`form-control ${onInvalid(errors?.name)}`}
              type="text"
              {...register("name")}
            />
            <ErrorMessage
              name={"Nome"}
              type={errors?.name?.type?.toString()}
              min={3}
              max={100}
            />
          </FormGroup>
        </Col>
        <Col md={12}>
          <FormGroup className="form-group">
            <label htmlFor="description">DESCRIÇÃO</label>
            <textarea
              className={`form-control ${onInvalid(errors?.description)}`}
              rows={3}
              {...register("description")}
            ></textarea>
            <ErrorMessage
              name={"Descrição"}
              type={errors?.description?.type?.toString()}
              max={255}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className="form-group">
            <label htmlFor="layout">URL *</label>
            <div className={`input-group ${onInvalid(errors?.layout)}`}>
              <span className="input-group-text">/</span>
              <input
                placeholder=" Ex: /registrations"
                className="form-control"
                type="text"
                {...register("layout")}
              />
            </div>
            <ErrorMessage
              name={"URL"}
              type={errors?.layout?.type?.toString()}
              min={3}
              max={50}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className="form-group">
            <label>ÍCONE *</label>
            <div className="col-auto">
              <div className={`input-group ${onInvalid(errors?.layout)}`}>
                {iconsFiltered?.icon ? (
                  <div className="input-group-append d-flex align-items-center iconFilter">
                    <BvIcon
                      name={iconsFiltered.icon}
                      variant="duo"
                      className="mx-1"
                      width={30}
                      height={30}
                    />
                  </div>
                ) : iconEdit.length > 0 ? (
                  <div className="input-group-append d-flex align-items-center iconFilter">
                    <BvIcon
                      name={iconEdit?.[0]?.icon}
                      variant="duo"
                      className="mx-1"
                      width={30}
                      height={30}
                    />
                  </div>
                ) : null}
                <input
                  type="text"
                  className="form-control"
                  disabled={true}
                  value={
                    iconsFiltered?.name
                      ? iconsFiltered?.name
                      : iconEdit?.[0]?.name
                  }
                />
                <div className="input-group-append d-flex align-items-center iconSearch">
                  <a onClick={() => showOffCanvas(true)}>
                    <span className="input-group-text">
                      <i className="fas fa-search"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <ErrorMessage
              name={"Ícone"}
              type={errors?.layout?.type?.toString()}
              min={3}
              max={50}
            />
          </FormGroup>
        </Col>
      </Row>
    );
  };

  return (
    <ModalDefault
      title={pageEdit?.name ? "Editar página" : "Inserir uma nova página"}
      show={show}
      icon="article"
      onClose={handleClose}
      sizeModal={"lg"}
      showFooter={true}
      buttonText={isLoadingSubmit ? "Salvando..." : "Salvar"}
      showButtonSpinner={isLoadingSubmit}
      disabledSubmit={isLoadingSubmit}
      handleSubmit={handleSubmit(onSubmit)}
      backdrop="static"
      backgroundColor="#f8f9fa"
    >
      <div
        className="ModalAccessPageCollapseInsert"
        data-testid="ModalAccessPageCollapseInsert"
      >
        {renderContent()}
        <ModalOffCanvas
          title="Bevi Icon"
          show={showModalOffCanvas}
          body={<IconGallery handleSelect={handleSelect} />}
          onClose={() => setShowModalOffCanvas(false)}
        />
      </div>
    </ModalDefault>
  );
};

export default ModalAccessPageCollapseInsert;
